import ls from 'store2'
import Base64 from '@/util/encryptlong'
import comfunction from '@/util/comfunction'
export const getCurToken = () => {  //是否有token
    const userInfo = JSON.parse(Base64.decode(ls.page("userInfo"))) || {}
    
    //return `Basic  b2NtX3Rlc3Q6RlZ2WHRCS1B5YmY3cjZNM3BnSDdhV0xPMHRrRkxic28=`
    if (!comfunction.isEmptyObject(userInfo)) {
        return userInfo.token_type + ' ' + userInfo.access_token
    } else {
        return false
    }

}

export const setUserInfo = (userInfo) => {
    let userInfoStr = Base64.encode(JSON.stringify(userInfo));
    ls.page("userInfo", userInfoStr);
}